import { useTranslation } from 'react-i18next';

import type { AvailabilityDto } from '@/services/ws-post/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { generatePath, useNavigate, useParams } from '@/js/libs/router';
import { useNotification } from '@/js/libs/ui/src/V2';

import { getUnavailablePositionType } from '../helpers';
import type { SavedPostCampaignRouteParams } from '../types';

type AvailabilityUpdatedHandler = (updatedItems: AvailabilityDto[]) => void;

export const useAvailabilityUpdatedHandler = (): AvailabilityUpdatedHandler => {
  const [t] = useTranslation(['backend', 'common', 'postCampaign']);
  const { campaignId, status } = useParams<SavedPostCampaignRouteParams>();
  const navigate = useNavigate<AvailabilityDto[]>();
  const notify = useNotification();

  const handleAvailabilityUpdated = useCallbackRef<AvailabilityUpdatedHandler>((updatedItems) => {
    const unavailablePositionType = getUnavailablePositionType(updatedItems);
    const positionsStepPath = generatePath('/orders/post-campaigns/:status/:campaignId/edit-positions/:positionType?', {
      positionType: unavailablePositionType,
      status,
      campaignId: campaignId.toString(),
    });

    navigate(positionsStepPath, { state: updatedItems });
    notify.warn({ body: t('postCampaign:REVIEW_UPDATED_AVAILABILITY_WARNING') });
  });

  return handleAvailabilityUpdated;
};
